import React, { memo } from 'react';
import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import Select from '../helpers/Select';
import Button from '../helpers/Button';

import uniqueId from '../../utils/uniqueId';

const selectId = uniqueId();

const AddFundPopup = props => {
  const { isValid, onClose, onChange, suggestCompany, suggestProject, onCreate, statuses } = props;

  const header = 'New Fund';
  const footer = (
    <>
      <Button key="create" className="btn-primary" disabled={!isValid} onClick={onCreate}>
        Create
      </Button>
      <Button key="cancel" onClick={onClose}>
        Cancel
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="newFundRecord">
      <div className="row media-450">
        <div className="col-xs-12">{suggestCompany}</div>
      </div>
      <div className="row media-450">
        <div className="col-xs-6">{suggestProject}</div>
        <FormGroup className="col-xs-6">
          <Select
            id={selectId}
            label="Current Status"
            name="newFund.currentStatus"
            onChange={onChange}
            options={statuses}
            showLabel
            showValue
          />
        </FormGroup>
      </div>
    </Popup>
  );
};

export default memo(AddFundPopup);
